import { SvgIcon, SvgIconBaseProps } from '@honeycomb/ui-core';
import * as React from 'react';

export function TwitterIcon(props: SvgIconBaseProps): React.JSX.Element {
    return (
        <SvgIcon {...props} viewBox="0 0 40 40">
            <g fill="none" fillRule="evenodd">
                <path
                    d="M5.714 0h28.572A5.715 5.715 0 0 1 40 5.714v28.572A5.715 5.715 0 0 1 34.286 40H5.714A5.715 5.715 0 0 1 0 34.286V5.714A5.715 5.715 0 0 1 5.714 0"
                    fill="#2CACE3"
                />
                <path
                    d="M30.877 12.408a8.995 8.995 0 0 1-2.656.73 4.56 4.56 0 0 0 2.013-2.529 9.996 9.996 0 0 1-2.911 1.115 4.57 4.57 0 0 0-7.923 3.124c-.002.347.041.691.128 1.028a12.968 12.968 0 0 1-9.464-4.797 4.693 4.693 0 0 0-.643 2.313c0 1.537.774 2.969 2.059 3.81a4.94 4.94 0 0 1-2.099-.556v.042a4.596 4.596 0 0 0 3.683 4.498 5.464 5.464 0 0 1-1.199.172 5.236 5.236 0 0 1-.857-.087 4.513 4.513 0 0 0 4.286 3.17 9.187 9.187 0 0 1-5.701 1.968 9.981 9.981 0 0 1-1.113-.043 13.111 13.111 0 0 0 7.023 2.055c7.147.068 12.994-5.672 13.061-12.817v-.845a10.012 10.012 0 0 0 2.313-2.351"
                    fill="#FFF"
                />
            </g>
        </SvgIcon>
    );
}
